import { CardShell } from "@/shared/ui/CardShell";
import { CardMenu } from "@/shared/ui/CardMenu";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { paymentMethodsConfig } from "./data";
import { DarkPaymentCard } from "./components/DarkPaymentCard";
import { LightPaymentCard } from "./components/LightPaymentCard";

export function PaymentMethodsClient() {
  const { t } = useTranslation();
  const { cards } = paymentMethodsConfig;

  return (
    <CardShell className="col-span-full md:col-span-2">
      <div className="flex items-start justify-between">
        <p className="text-sm font-medium text-muted">{t.crm.paymentMethods}</p>
        <CardMenu />
      </div>

      <div className="mt-5 grid grid-cols-2 gap-5">
        {cards.map((card) =>
          card.variant === "dark" ? (
            <DarkPaymentCard key={card.id} card={card} />
          ) : (
            <LightPaymentCard key={card.id} card={card} />
          )
        )}
      </div>
    </CardShell>
  );
}
